module.exports = __webpack_public_path__ + "static/media/menu-bars.65ad1a98.svg";